export var AcceptType;
(function (AcceptType) {
    AcceptType[AcceptType["current"] = 0] = "current";
    AcceptType[AcceptType["incoming"] = 1] = "incoming";
    AcceptType[AcceptType["both"] = 2] = "both";
})(AcceptType || (AcceptType = {}));
